var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHostages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.27 32.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fc0;\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #a67c52;\n        stroke-miterlimit: 10;\n        stroke-width: .25px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path4711",
    className: "cls-1",
    d: "M.35,8.46C.36,7.54,2.24.04,8.83.28c6.6.25,8.18,7.34,8.17,8.26-.02.92-5.46-2.69-8.25-2.71C5.98,5.84.33,9.39.35,8.46Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path4713",
    className: "cls-2",
    d: "M.35,8.46C.36,7.54,2.24.04,8.83.28c6.6.25,8.18,7.34,8.17,8.26-.02.92-5.46-2.69-8.25-2.71C5.98,5.84.33,9.39.35,8.46"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path4715",
    className: "cls-1",
    d: "M13.57,2.03c.61.69,4.99,4.44,3,9.05-1.97,4.6-10.63,17.78-12.93,21.6-1.03-2.07-1.36-2.22-3.43-5.71,2.32-3.98,10.42-15.9,12.63-20.02,2.21-4.1-.02-5.27.72-4.91Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path4717",
    className: "cls-2",
    d: "M13.57,2.03c.61.69,4.99,4.44,3,9.05-1.97,4.6-10.63,17.78-12.93,21.6-1.03-2.07-1.36-2.22-3.43-5.71,2.32-3.98,10.42-15.9,12.63-20.02,2.21-4.1-.02-5.27.72-4.91"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path4719",
    className: "cls-1",
    d: "M3.72,1.95c-.63.69-5.01,4.44-3.02,9.05,1.99,4.6,10.66,17.78,12.96,21.6,1.03-2.07,1.36-2.22,3.43-5.73-2.32-3.96-10.44-15.88-12.64-20-2.21-4.12.02-5.27-.72-4.91Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path4721",
    className: "cls-2",
    d: "M3.72,1.99c-.63.69-5.01,4.44-3.02,9.05,1.99,4.6,10.66,17.78,12.96,21.6,1.03-2.07,1.36-2.22,3.43-5.73-2.32-3.96-10.44-15.88-12.64-20-2.21-4.12.02-5.27-.72-4.91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHostages);
export default __webpack_public_path__ + "static/media/hostages.e828f89ef8bf76108b6a8f418f70d76f.svg";
export { ForwardRef as ReactComponent };